'use client';
import { Button } from '@mui/material';

import { AbgDialog, AbgTypography, useTranslation } from '@abg/kit-base';

import { useBookingWidgetContext } from '../../organisms/BookingWidget/hooks';

import {
  button,
  buttonContainer,
  content,
  dialogWrapper,
  title,
} from './proof-of-employment-modal.styling';

interface ProofOfEmploymentModalProps {
  isOpen: boolean;
  onRemoveAwd: () => void;
  onConfirmEligible: () => void;
}

export const ProofOfEmploymentModal = ({
  isOpen,
  onRemoveAwd,
  onConfirmEligible,
}: ProofOfEmploymentModalProps) => {
  const bookingWidgetContext = useBookingWidgetContext();
  const i18nData = bookingWidgetContext?.model?.i18n || {};
  const t = useTranslation(i18nData);

  const modalTitle = t('bookingWidget.proofOfEmployment.modal.title');
  const modalDescription = t(
    'bookingWidget.proofOfEmployment.modal.description',
  );
  const removeText = t(
    'bookingWidget.proofOfEmployment.modal.button.remove.text',
  );
  const eligibleText = t(
    'bookingWidget.proofOfEmployment.modal.button.eligible.text',
  );

  return (
    <AbgDialog
      styles={{
        wrapper: dialogWrapper,
        content: content,
        title: title,
        controls: buttonContainer,
      }}
      isOpen={isOpen}
      onClose={() => {}}
      hasCloseIcon={false}
      divider={true}
      testId="proof-of-employment-modal"
      title={
        <AbgTypography
          variant="bodyLargeBold"
          data-testid="proof-of-employment-dialog-title"
        >
          {modalTitle}
        </AbgTypography>
      }
      controls={
        <>
          <Button
            className="primary"
            sx={button}
            onClick={onRemoveAwd}
            data-testid="proof-of-employment-remove-button"
          >
            {removeText}
          </Button>
          <Button
            className="secondary"
            sx={button}
            onClick={onConfirmEligible}
            data-testid="proof-of-employment-eligible-button"
          >
            {eligibleText}
          </Button>
        </>
      }
    >
      <AbgTypography
        variant="bodySmallRegular"
        data-testid="proof-of-employment-dialog-description"
      >
        {modalDescription}
      </AbgTypography>
    </AbgDialog>
  );
};
